import "core-js/modules/es6.array.map";
import "core-js/modules/es6.array.filter";
export var filter = function filter(args, condition) {
  return Array.prototype.filter.call(args, condition);
};
export var map = function map(args, mapper) {
  return Array.prototype.map.call(args, mapper);
};